export enum WX_SCOPE {
    /** 静默授权 */
    base = 'snsapi_base',
    /** 主动调起授权 */
    userinfo = 'snsapi_userinfo'
}

/**
 * 微信网页授权
 * @param appId 公众号的唯一标识
 * @param scope 应用授权作用域
 * @param state
 * @desc https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_webpage_authorization.html
 * @returns
 */
export function wxOauth (appId: string, scope: WX_SCOPE, state?: any) {
  let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?'
  let path = window.location.href.split('?')[0] || ''
  let search = window.location.href.split('?')[1] || ''
  search = decodeURIComponent(search)
  // 如果连接里面有state和code,先去掉
  search = search.replace(`&state=${getQueryString('state')}`, '')
  search = search.replace(`&code=${getQueryString('code')}`, '')

  let redirectUri = path + (search ? '?' + encodeURIComponent(search) : '')

  // 使用 wxlogin.sogou-diskmgr.com 作为微信授权回调域名
  // nginx 根据路径重定向到对应的目标域名
  const wxProxyDomainMap = {
    'sogou-pdf-vip.vconew3.com': 'pdf-sogou-vip',  // -> sogou-pdf-vip.vconew3.com
    'pdfvip.ijinshan.com': 'pdf-ijinshan'          // -> pdfvip.ijinshan.com
  }
  const proxyPath = wxProxyDomainMap[location.host]
  if (proxyPath) {
    const pagePath = path.replace(/^https?:\/\/[^/]+/, '')
    // 编码查询参数，避免特殊字符导致 URL 截断
    const queryParams = search ? `?${encodeURIComponent(search)}` : ''
    redirectUri = `https://wxlogin.sogou-diskmgr.com/pc-tools/wxlogin/${proxyPath}${pagePath}${queryParams}`
  }

  const params = {
    appid: appId,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: scope || 'snsapi_userinfo',
    state: state || ''
  }

  let i
  const arr = []
  for (i in params) {
    arr.push(i + '=' + params[i])
  }

  const paramStr = arr.join('&')
  url += paramStr + '#wechat_redirect'

  // @ts-ignore
  if (window.__PRERENDER_INJECTED__ === 'prerender') {
    return
  }
  window.location.href = url
}
function getQueryString (name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = decodeURIComponent(window.location.search)
    .substr(1)
    .match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}
